import styled from '@emotion/styled';
import { responseFont } from '@landsbankinn/ui';
import React, { useState, forwardRef } from 'react';
import { animated, useSpring } from 'react-spring';

interface IProps {
  title?: string;
  active?: boolean;
  onClick?: any;
  style: any;
}

export const ThirdLevelItemHost = styled(animated.a)<any>`
  display: block;
  position: relative;
  color: ${(props) => props.theme.colors.foreground};
  font-family: ${(props) => props.theme.font.familySerifCond};
  font-size: 22px;
  font-weight: 500;
  border-bottom: 1px solid;
  border-bottom-color: ${(props) => (props.active ? '#1e3d5a' : '#f5f7f7')};
  line-height: 2.1em;
  padding: 6px 0;
  cursor: pointer;
  transition: border-color 220ms ease-in-out;
  text-decoration: none;
  overflow: hidden;

  @media (min-height: 800px) {
    font-size: 24px;
    line-height: 2.2em;
  }

  @media (min-height: 900px) {
    ${responseFont(22, 30)}
    line-height: 2.2em;
  }

  @media (min-height: 961px) {
    ${responseFont(24, 30)}
    line-height: 2.3em;
  }

  @media (min-height: 1020px) {
    ${responseFont(24, 30)}
    line-height: 2.5em;
    padding: 8px 0;
  }
`;

const Underline = styled(animated.span)<any>`
  display: block;
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  background: ${(props) => props.theme.colors.primary};
  height: ${(props) => (props.active ? 3 : 2)}px;
`;

export const ThirdLevelItem = forwardRef(function ThirdLevelItem(
  { title, active, ...rest }: IProps,
  ref,
) {
  const [hover, setHover] = useState(false);
  const p = useSpring({
    x: hover ? '-95%' : active ? '-95%' : '-100%',
    opacity: hover ? 1 : active ? 1 : 0,
    from: { x: active ? '-95%' : '-100%', opacity: active ? 1 : 0 },
  });

  return (
    <ThirdLevelItemHost
      ref={ref}
      {...rest}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onFocus={() => setHover(true)}
      onBlur={() => setHover(false)}
    >
      {title}
      <Underline
        style={{
          opacity: p.opacity,
          transform: p.x.to((x) => `translate3d(${x},0,0)`),
        }}
        active={active}
      />
    </ThirdLevelItemHost>
  );
});
